// Zero-width space, BOM, and C0 controls / DEL that are not whitespace.
const REMOVED_CHARS = /[\u200B\uFEFF\u0000-\u0008\u000E-\u001F\u007F]/g

// Line breaks, tab and NBSP. A paragraph is one line, so each becomes a plain space.
const WHITESPACE_CHARS = /[\t\n\v\f\r\u0085\u00A0\u2028\u2029]/g

/** Characters that would start a new line. Not global, so `test` has no state. */
export const LINE_BREAK_CHARS = /[\n\v\f\r\u0085\u2028\u2029]/

/**
 * Flatten pasted text to one line: drop zero-width and control characters,
 * turn line breaks and other whitespace into spaces, collapse runs. The ends are
 * not trimmed, so a single-line paste keeps its spaces.
 */
export const sanitizePastedText = (text: string): string =>
    text.replace(REMOVED_CHARS, '').replace(WHITESPACE_CHARS, ' ').replace(/ {2,}/g, ' ')
